import { SWITCH_SENDOVER_TO_SENDOUT_TYPES } from '../ConvertSendoverToSendoutDrawer/ConvertSendoverToSendoutDrawer.constants';

export const SwitchSendoverOptions = [
  {
    title: 'Switch and Send Mail',
    value: SWITCH_SENDOVER_TO_SENDOUT_TYPES.WithMail,
    visible: true
  },
  {
    title: 'Switch without Mail',
    value: SWITCH_SENDOVER_TO_SENDOUT_TYPES.WithoutMail,
    visible: true
  }
];
